// extracted by mini-css-extract-plugin
export default {"input":"styles_input__HvH-S","popup":"styles_popup__aLtpo"};